export const FETCH_SITE = 'FETCH_SITE';
export const CHECK_SITE = 'CHECK_SITE';
export const CREATE_SITE = 'CREATE_SITE';
export const CREATE_ADMIN_SITE = 'CREATE_ADMIN_SITE';
export const UPDATE_SITE = 'UPDATE_SITE';
export const DELETE_SITE = 'DELETE_SITE';
